import {CheckOutlined, CloseOutlined} from '@ant-design/icons/lib';
import {Card, Switch} from 'antd';
import {
  TokenizationMethods as Methods,
  useDisableTokenizationMethodMutation,
  useEnableTokenizationMethodMutation
} from 'api/generated';
import {PropertyList} from 'components';
import {useAccessLevel} from 'hooks/useAccessLevel';
import React, {useState} from 'react';
import styled from 'styled-components';
import {SectionProps} from './types';

const List = styled(PropertyList)`
  li {
    padding-top: 8px;
    padding-bottom: 8px;
  }
`;

export const TokenizationMethods: React.FC<SectionProps> = ({cardProps, formProps, account}) => {
  const {isAdmin} = useAccessLevel();
  const [enableTokenizationMethod] = useEnableTokenizationMethodMutation();
  const [isLoading, setLoading] = useState({
    [Methods.APPLEPAY]: false,
    [Methods.GOOGLEPAY]: false,
    [Methods.CLICKTOPAY]: false
  });
  const [disableTokenizationMethod] = useDisableTokenizationMethodMutation();

  if (!isAdmin) return null;
  if (!account) return <Card {...cardProps} title="Tokenization methods" />;

  const toggleTokenizationMethod = async (method: Methods, enabled: boolean) => {
    setLoading((state) => ({...state, [method]: true}));
    try {
      if (enabled) {
        await enableTokenizationMethod({
          variables: {accountId: account.id, method}
        });
      } else {
        await disableTokenizationMethod({
          variables: {accountId: account.id, method}
        });
      }
    } finally {
      setLoading((state) => ({...state, [method]: false}));
    }
  };

  return (
    <Card {...cardProps} title="Tokenization methods">
      <List
        omitEmpty
        labelWidth={100}
        properties={[
          {
            label: 'Google Pay',
            value: (
              <Switch
                loading={isLoading[Methods.GOOGLEPAY]}
                onChange={(checked) => toggleTokenizationMethod(Methods.GOOGLEPAY, checked)}
                checked={Boolean(account.tokenizationMethods?.googlePay?.enabled)}
                checkedChildren={<CheckOutlined />}
                unCheckedChildren={<CloseOutlined />}
              />
            )
          },
          {
            label: 'Apple Pay',
            value: (
              <Switch
                loading={isLoading[Methods.APPLEPAY]}
                onChange={(checked) => toggleTokenizationMethod(Methods.APPLEPAY, checked)}
                checked={Boolean(account.tokenizationMethods?.applePay?.enabled)}
                checkedChildren={<CheckOutlined />}
                unCheckedChildren={<CloseOutlined />}
              />
            )
          },
          {
            label: 'Click to Pay',
            value: (
              <Switch
                loading={isLoading[Methods.CLICKTOPAY]}
                onChange={(checked) => toggleTokenizationMethod(Methods.CLICKTOPAY, checked)}
                checked={Boolean(account.tokenizationMethods?.clickToPay?.enabled)}
                checkedChildren={<CheckOutlined />}
                unCheckedChildren={<CloseOutlined />}
              />
            )
          }
        ]}
      />
    </Card>
  );
};
